import { Dimensions } from 'react-native';

export const getMaxGridColunm = () => {
  const { width } = Dimensions.get('window');

  const maxGridColumn = Math.floor((width - 100) / 200);
  return { maxGridColumn };
};
